import {
  COLORS,
  DEFAULT_TRANSITION_ALL
} from "utils/styles";
import React from "react";
import styled from "styled-components";

const IconContainer = styled.div`
  ${DEFAULT_TRANSITION_ALL};
  height: 40px;
  min-width: 40px;
  border-radius: 15px;
  overflow: hidden;
  filter: drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.1));
  margin: 5px;
  cursor: pointer;
  display: flex;
  align-content: center;
  justify-content: center;
  padding-left: ${({ padLeft }) => (padLeft ? "1rem" : "0")};
  padding-right: ${({ padLeft }) => (padLeft ? "0.5rem" : "0")};
  background-color: ${({ iconColor }) => iconColor ? iconColor : COLORS.WHITE};
  &:hover {
    transform: scale(1.15);
    z-index: 100;
  }
`;

const IconWrapper = styled.i`
  display: block;
  align-self: center;

  &.md-rotate-180 {
    transform: rotate(180deg) translateX(0) !important;
  }
`;

export default function Icon(props) {
  const {
    children,
    iconType,
    additionalClasses,
    padLeft,
    iconColor,
  } = props;

  return (
    <IconContainer iconColor={iconColor} padLeft={padLeft}>
      {iconType ? (
        <IconWrapper
          className={`material-icons-round md-dark md-18 ${additionalClasses}`}
        >
          {iconType}
        </IconWrapper>
      ) : null}
      {children}
    </IconContainer>
  );
}
